import React from 'react';
import UserDashboardHelpForm from 'components/UserDashboard/UserDashboardHelpForm/UserDashboardHelpForm';

const UserDashboardHelp = () => <UserDashboardHelpForm />;

export default UserDashboardHelp;
